import traverse from 'neotraverse';
import { ISection } from '../../section-block/contracts';
import { getQuestionsAndSelects } from '../conditionals/helpers';
import { FormPageValidatorFunctionType } from './form-page-validators';

function translateSelectAnswer(sections: ISection[], questionId: string, answerString: string | undefined) {
	const { allProvidesSelects } = getQuestionsAndSelects(sections, questionId);

	return allProvidesSelects.find(a => a.name === answerString)?.id;
}

// this is our opportunity to ensure the fee is specified
export const validateTransactionBlock: FormPageValidatorFunctionType = async props => {
	// should never happen
	if (!props.layout) return { success: false, errorMessage: 'Question configuration is invalid' };

	// HACK: we need to scan the layout for our data!
	const theTra = traverse(props.layout);
	const questionNodes = theTra.nodes().filter(a => a?.name === props.field.name);
	const recurringTransactionNode = questionNodes.find(a => a?.recurringEnabled);

	const feeId =
		recurringTransactionNode?.recurringEnabled && recurringTransactionNode.recurringIntervalQuestionId
			? recurringTransactionNode.recurringIntervalMap?.[
					translateSelectAnswer(
						props.sections,
						recurringTransactionNode.recurringIntervalQuestionId,
						props.answers.find(a => a.questionName === recurringTransactionNode.recurringIntervalQuestionId)?.answer?.answerString
					) ?? ''
				]
			: null;

	const answer = props.answers.find(a => a.questionName === props.field.name);
	if (answer) {
		const currencies = await props.formFinancialApiHelpers.fetchCurrencies();
		const lines = answer.data!.lineItems as { feeId?: number; amount: number }[];
		lines[0].feeId = feeId;
		answer.answer!.answerJson = JSON.stringify({
			feeId,
			amount: lines.reduce((prev, a) => prev + a.amount, 0),
			currency: currencies?.default ?? 'AUD'
		});
	}

	return { success: true };
};
